// material-ui
import { createTheme } from "@mui/material/styles"

// third-party
import { presetPalettes } from "@ant-design/colors"

// project import
import ThemeOption from "./theme"

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
  const colors = presetPalettes

  const greyPrimary = [
    "#ffffff",
    "#fffaf9",
    "#fcf5f4",
    "#f7f1ef",
    "#28292B1A",
    "#cdc7c5",
    "#afa9a8",
    "#857f7e",
    "#706a69",
    "#504b4a",
    "#29282e",
  ]
  const greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"]
  const greyConstant = ["#fafafb", "#e6ebf1"]

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant]

  const paletteColor = ThemeOption(colors)

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],
        secondary: paletteColor.grey[500],
        disabled: paletteColor.grey[400],
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      divider: paletteColor.grey[200],
      background: {
        paper: paletteColor.grey[0],
        default: paletteColor.grey.A50,
      },
    },
  })
}

export default Palette
